<template>
    <!--  -->
    <div>
        <!--  -->
        <div class="w-full flex flex-col px-4">
            <!--  -->
            <div class="p-4 w-full">
                <!--  -->
                <p class="text-lg lg:text-xl font-normal">
                    Welcome back,<b>{{ currentUser.username }} 👋🏻</b>
                </p>
                <!--  -->

                <!--  -->
                <p class="text-gray-500 font-light text-base">
                    Your progress this week is Awesome. let's keep it up and get a lot
                    of points reward!
                </p>
                <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div class="flex flex-col lg:flex-row gap-4">
                <!--  -->
                <div class="w-full lg:w-1/4 rounded-lg" v-if="currentUser.type == 'Admin' || currentUser.type == 'CEO'">
                    <flat-card statSubtitle="Total Sellers" :statTitle="TotalSeller" :userType="currentUser.type" statArrow="down" statPercentColor="text-green-500" statIconName="people" statIconColor="bg-green-200"/>
                </div>
                <!--  -->
                
                <!-- -->
                <div class="w-full lg:w-1/4 rounded-lg">
                    <flat-card statSubtitle="Total orders" :statTitle="TotalOrder" :userType="currentUser.type" statArrow="up" filter="true" action="Orders" :timeserch="timeserchorders" :loading="loadingorders" :from="from_orders" :to="to_orders" statPercentColor="text-primary-500" statIconName="local_grocery_store" statIconColor="bg-indigo-300" @ChangeTypeDateRevenu="ChangeTypeDateRevenu" @FindRecords="FindRecords" :sellers="sellers" :timeserchseller="timeserchseller" @ChangeSeller="ChangeSellerOrders" :products="products" :timeserchproduct="timeserchproduct"/>
                </div>
                <!-- -->
                
                <!--  -->
                <div class="w-full lg:w-1/4 rounded-lg" v-if="currentUser.type == 'Seller' || currentUser.type == 'Admin' || currentUser.type == 'CEO'">
                    <flat-card statSubtitle="Total Products" :statTitle="TotalProduct" :userType="currentUser.type" statArrow="down" statPercentColor="text-orange-500" statIconName="local_mall" statIconColor="bg-orange-200"/>
                </div>
                <!--  -->

                <!-- -->
                <div class="w-full lg:w-1/4 rounded-lg">
                    <!-- -->
                    <div class="w-full h-full p-4 flex items-center justify-items-center bg-white rounded-lg border shadow-custom box-3">
                        <!--  -->
                        <div class="w-full flex flex-col gap-4">
                            <!--  -->
                            <div class="flex items-center justify-end">
                                <!--  -->
                                <div class="relative flex">
                                    <!--  -->
                                    <div class="w-full h-10 flex gap-1 transition-all duration-500 relative rounded p-1" >
                                        <!--  -->
                                        <button class="rounded-md border-2 text-xs hover:bg-orange-100 px-2 py-1" name="Confirmation" :class="timeserchconfirm == 'all' ? 'border-orange-500' : 'text-gray-600  border-gray-600'" value="all" @click=" ChangeTypeDateRevenu($event); timeserchconfirm = 'all';">
                                            All
                                        </button>
                                        <!--  -->
            
                                        <!--  -->
                                        <button class="rounded-md border-2 hover:bg-orange-100 border-orange-50 px-2 py-1" name="Confirmation" :class="timeserchconfirm == 'betweendate' ? 'border-orange-500' : 'text-gray-600 border-gray-600'" value="betweendate" @click="ChangeTypeDateRevenu($event); timeserchconfirm = 'betweendate';">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"/>
                                            </svg>
                                        </button>
                                        <!--  -->
                                    </div>
                                    <!--  -->
            
                                    <!--  -->
                                    <div v-if="timeserchconfirm == 'betweendate'" class="absolute z-10 rounded-lg right-0 bg-white date-container">
                                        <!--  -->
                                        <div class="inline-block mt-2 w-2/5 pr-1">
                                            <!--  -->
                                            <div class="border hover:border-orange-400 w-full focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1" >
                                                <!--  -->
                                                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                    <p>
                                                        <label for="date" class="bg-white text-gray-700 px-1">From 
                                                            <span class="text-orange-500">*</span>
                                                        </label>
                                                    </p>
                                                </div>
                                                <!--  -->
            
                                                <!--  -->
                                                <p>
                                                    <input :name="action" v-model="fromDate" class="w-full px-1 py-1 text-gray-700 bg-gray-200 rounded" id="from" type="date" />
                                                </p>
                                                <!--  -->
                                            </div>
                                            <!--  -->
                                        </div>
                                        <!--  -->
            
                                        <!--  -->
                                        <div class="inline-block mt-2 w-2/5 pr-1">
                                            <div class="border hover:border-orange-400 w-full focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1" >
                                                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                    <p>
                                                    <label for="date" class="bg-white text-gray-700 px-1">To 
                                                        <span class="text-orange-500">*</span></label>
                                                    </p>
                                                </div>
                                                <p>
                                                    <input :name="action" v-model="toDate" class="w-full px-1 py-1 text-gray-700 bg-gray-200 rounded" id="to" type="date" />
                                                </p>
                                            </div>
                                        </div>
                                        <!--  -->
            
                                        <!--  -->
                                        <div class="inline-block mt-2 w-1/5 pr-1">
                                            <button @click="FindRecords('Confirmation', fromDate, toDate)" :disabled="fromDate == null || toDate == null" class="w-full px-2 py-2 text-white font-light tracking-wider bg-gray-900 rounded">
                                                Find
                                            </button>
                                        </div>
                                        <!--  -->
                                    </div>
                                    <!--  -->
                                </div>
                                <!--  -->
                            </div>
                            <!--  -->
        
                            <!--  -->
                            <div class="flex flex-col items-center justify-center gap-4">
                                <rounded-chart :percentage="ConfirmationRate" color="#23415b"/>
                                <p>Confirmation Rate</p>
                            </div>
                            <!--  -->
                        </div>
                        <!--  -->
                    </div>
                    <!-- -->
                </div>
                <!--  -->

                <!-- -->
                <div class="w-full lg:w-1/4 rounded-lg" v-if="currentUser.type == 'Seller'">
                    <!-- -->
                    <div class="w-full h-full p-4 flex items-center justify-items-center bg-white rounded-lg border shadow-custom box-3" >
                        <!--  -->
                        <div class="w-full flex flex-col items-center justify-center gap-4">
                            <rounded-chart :percentage="DeliveryRate" />
                            <p>Delivery Rate</p>
                        </div>
                        <!--  -->
                    </div>
                    <!-- -->
                </div>
                <!--  -->
            </div>
            <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div class="p-4">
            <group-card statSubtitle="Accounting" :datasAcounting="Accounting" statArrow="up" filter="true" filterSeller="true" :timeserchseller="timeserchsellerAccounting" action="Accounting" :sellers="sellers" :timeserch="timeserchaccounting" :loading="loadingaccounting" :userType="currentUser" :from="from_accounting" :to="to_accounting" statPercentColor="text-red-500" statIconName="monetization_on" statIconColor="bg-yellow-500" @ChangeTypeDateRevenu="ChangeTypeDateRevenu" @FindRecords="FindRecords" @ChangeSeller="ChangeSellerAccounting"/>
        </div>
        <!--  -->

        <!--  -->
        <div class="flex flex-col lg:flex-row gap-4 px-4">
            <!--  -->
            <div class="w-full lg:w-4/6 rounded-lg">
                <card-stats statSubtitle="Confirmation" titleRate="Confirmation Rate" :datas="Confirmation" :rate="ConfirmationRate" statArrow="up" filter="true" action="Confirmation" :timeserch="timeserchconfirm" :userType="currentUser.type" :loading="loadingconfirm" :from="from_confirm" :to="to_confirm" statPercentColor="text-primary-500" statIconName="timeline" statIconColor="#FFFRRR" @ChangeTypeDateRevenu="ChangeTypeDateRevenu" @FindRecords="FindRecords" :sellers="sellers" :timeserchseller="timeserchseller" @ChangeSeller="ChangeSellerConfirmation" :products="products" :timeserchproduct="timeserchproduct"/>
            </div>
            <!--  -->

            <!--  -->
            <div class="flex flex-col gap-4 w-full lg:w-2/6 rounded-lg">
                <!--  -->
                <div class="flex-1" v-if="currentUser.type == 'Admin' || currentUser.type == 'CEO'">
                    <flat-card statSubtitle="Fees" :statTitle="Revenue" currency="true" filter="true" filterSeller="true" :timeserch="timeserchfees" :timeserchseller="timeserchsellerFees" :from="from_fees" :userType="currentUser.type" action="Revenue" :to="to_fees" :sellers="sellers" statArrow="down" statPercentColor="text-green-500" statIconName="monetization_on" statIconColor="bg-green-200" @ChangeTypeDateRevenu="ChangeTypeDateRevenu" @FindRecords="FindRecords" :loading="loadingfees" @ChangeSeller="ChangeSellerFees"/>
                </div>
                <!--  -->

                <!--  -->
                <div class="flex-1" v-if="currentUser.type == 'Seller' || currentUser.type == 'Admin' || currentUser.type == 'CEO'">
                    <flat-card statSubtitle="Expedition fees paid" :statTitle="FeesExpeditions" :count="countExpeditions" :userType="currentUser.type" countText="Expeditions" currency="true" statArrow="down" statPercentColor="text-red-500" statIconName="monetization_on" statIconColor="bg-red-200"/>
                </div>
                <!--  -->
            </div>
            <!--  -->
        </div>
        <!--  -->
    </div>
    <!--  -->
</template>

<script>
import FlatCard from '@/components/Cards/FlatCard.vue';
import GroupCard from '@/components/Cards/GroupCard.vue';
import CardStats from '@/components/Cards/CardStats.vue';
import RoundedChart from '@/components/Analytics/Cards/RoundedChart.vue';

export default {
    components: {
        FlatCard,
        GroupCard,
        CardStats,
        RoundedChart
    },
    data() {
        return {
            currentUser: {
                role: {},
            },
            sellers: [],
            products: [],
            Confirmation: [],
            countshipp: 0,
            countdeliv: 0,
            countcancell: 0,
            ConfirmationRate: 0,
            Delivery: [],
            DeliveryRate: 0,
            Accounting: [],
            dataDelivery: [0, 0, 0],
            TotalOrder: '',
            FeesExpeditions: '',
            fromDate: null,
            toDate: null,
            TotalSeller: '',
            TotalProduct: '',
            TotalOrdersPaid: '',
            TotalOrdersPendingPaid: '',
            TotalOrdersNotProcessed: '',
            TotalOrdersPendingProcessed: '',
            Revenue: '',
            countOrdersPaid: 0,
            countOrdersPendingPaid: 0,
            countOrdersProcessed: 0,
            countExpeditions: 0,
            countOrdersPendingProcessed: 0,
            timeserchdelivery: 'thismonth',
            timeserchsales: 'all',
            timeserchorders: 'all',
            timeserchrevenues: 'all',
            timeserchconfirm: 'all',
            timeserchdelivry: 'all',
            timeserchaccounting: 'all',
            timeserchfees: 'all',
            timeserchsellerAccounting: 'All',
            timeserchsellerFees: 'All',
            timeserchsellerDelivery: 'All',
            timeserchseller: '',
            timeserchproduct: null,
            from_sh: null,
            to_sh: null,
            from_orders: null,
            to_orders: null,
            from_paid: null,
            to_paid: null,
            from_revenues: null,
            to_revenues: null,
            from_confirm: null,
            to_confirm: null,
            from_delivery: null,
            to_delivery: null,
            from_accounting: null,
            to_accounting: null,
            from_fees: null,
            to_fees: null,
            loadingsales: false,
            loadingrevenu: false,
            loadingorders: false,
            loadingconfirm: false,
            loadingdelivery: false,
            loadingaccounting: false,
            loadingfees: false,
            idWharhouse: null,
            citiesPrices: [],
        };
    },
    async mounted() {
        await this.getUser();
        await this.getwharhouseId();

        await this.getTotalOrdersPaid({
            Response: 'Shippings',
            Seller: this.timeserchsellerDelivery,
            DateType: this.timeserchdelivery,
            country: await this.warhouseSelected,
        });

        await this.getSellers();
        await this.getProducts();

        await this.getTotalSeller();
        await this.getTotalProduct();

        await this.getTotalOrdersPaid({
            Response: 'Orders',
            DateType: this.timeserchorders,
            country: await this.warhouseSelected,
        });

        await this.getTotalOrdersPaid({
            Response: 'Accounting',
            Seller: this.timeserchsellerAccounting,
            DateType: this.timeserchaccounting,
            country: await this.warhouseSelected,
        });

        await this.getTotalOrdersPaid({
            Response: 'Confirmation',
            DateType: this.timeserchconfirm,
            country: await this.warhouseSelected,
        });

        await this.getTotalOrdersPaid({
            Response: 'Delivery',
            DateType: this.timeserchdelivry,
            country: await this.warhouseSelected,
        });

        await this.getTotalOrdersPaid({
            Response: 'Revenue',
            Seller: this.timeserchsellerFees,
            DateType: this.timeserchfees,
            country: await this.warhouseSelected,
        });

        await this.getTotalFeesExpeditions();

        if (this.currentUser.type == 'Seller') {
            const res = await this.$server.search('products', {
                seller: this.currentUser._id,
                limit: 4000,
            });
            if (res.content.results) {
                this.products = res.content.results;
            } else this.products = [];
        }
    },
    computed: {
        warhouseSelected() {
            return this.$store.getters['wharhouse/warhouseSelected'];
        },
    },
    watch: {
        warhouseSelected: async function(oldVal, newVal) {
            this.timeserchsales = this.timeserchorders = this.timeserchconfirm = this.timeserchdelivry = this.timeserchaccounting = this.timeserchfees = 'all';
            this.timeserchdelivery = 'thismonth';
            await this.getwharhouseId();

            await this.getSellers();
            await this.getProducts();

            await this.getTotalOrdersPaid({
                Response: 'Shippings',
                Seller: this.timeserchsellerDelivery,
                DateType: this.timeserchdelivery,
                country: await this.warhouseSelected,
            });
            await this.getTotalOrdersPaid({
                Response: 'Accounting',
                Seller: this.timeserchsellerAccounting,
                DateType: this.timeserchaccounting,
                country: await this.warhouseSelected,
            });
            await this.getTotalOrdersPaid({
                Response: 'Confirmation',
                DateType: this.timeserchconfirm,
                country: await this.warhouseSelected,
            });
            await this.getTotalOrdersPaid({
                Response: 'Delivery',
                DateType: this.timeserchdelivry,
                country: await this.warhouseSelected,
            });
            await this.getTotalOrdersPaid({
                Response: 'Orders',
                DateType: this.timeserchorders,
                country: await this.warhouseSelected,
            });
            await this.getTotalSeller();
            await this.getTotalProduct();
            await this.getTotalOrdersPaid({
                Response: 'Revenue',
                DateType: this.timeserchfees,
                Seller: this.timeserchsellerFees,
                country: await this.warhouseSelected,
            });
            await this.getTotalFeesExpeditions();
        },
    },
    methods: {
        async getwharhouseId() {
            await this.$store.dispatch('wharhouse/getwharhouseId').then(res => {
                this.idWharhouse = res;
            });
        },
        async getCitiesPrices() {
            const resCities2 = await this.$server.get('zones', {
                allCitiesAndFees: true,
                country: await this.warhouseSelected,
            });
            if (resCities2.content.length > 0) {
                for (let i in resCities2.content) {
                    for (let j in resCities2.content[i]._id.cities) {
                        this.citiesPrices.push({
                            name: resCities2.content[i]._id.cities[j],
                            price: resCities2.content[i]._id.price,
                        });
                    }
                }
            } else this.citiesPrices = [];
        },
        async getSellers() {
            if (this.currentUser.type != 'Seller') {
                const res = await this.$server.search('users', {
                    type: 'Seller',
                    countries: await this.warhouseSelected,
                    limit: 4000,
                });
                
                if (res.content.results && (this.currentUser.type == 'Admin' || this.currentUser.type == 'CEO')) {
                    this.sellers = res.content.results;
                    this.sellers.unshift('All');
                }
            }
        },
        async getProducts() {
            this.products = [];
            let filters = { 
                'details.warehouse': this.idWharhouse._id 
            };
            const res = await this.$server.search('products', filters);
            if (res.content.results) {
                this.products = res.content.results;
            } else this.products = [];
        },
        async ChangeTypeDateDelivery(event) {
            this.timeserchdelivery = event.target.value;
            if (event.target.value != 'betweendate') {
                this.dataDelivery = [0, 0, 0];
                await this.getTotalOrdersPaid({
                    Response: 'Shippings',
                    Seller: this.timeserchsellerDelivery,
                    DateType: this.timeserchdelivery,
                    country: await this.warhouseSelected,
                });
            }
        },
        async FindRecordShippings(from, to) {
            this.from_sh = from;
            this.to_sh = to;
            await this.getTotalOrdersPaid({
                DateType: 'betweendate',
                Response: 'Shippings',
                dates: { from: from, to: to },
                Seller: this.timeserchsellerDelivery,
                country: await this.warhouseSelected,
            });
        },
        async ChangeSellerAccounting(seller) {
            this.timeserchsellerAccounting = seller;
            await this.getTotalOrdersPaid({
                Response: 'Accounting',
                Seller: this.timeserchsellerAccounting,
                DateType: this.timeserchaccounting,
                country: await this.warhouseSelected,
            });
        },
        async ChangeSellerOrders(seller, action) {
            if (seller) {
                if (action && action == 'Seller') {
                    this.timeserchseller = seller;
                    this.timeserchproduct = null;
                    await this.getTotalOrdersPaid({
                        Response: 'Orders',
                        DateType: this.timeserchorders,
                        country: await this.warhouseSelected,
                        Seller: this.timeserchseller ? this.timeserchseller._id || this.timeserchseller : null,
                    });

                    if(this.timeserchseller != 'All') {
                        this.products = [];
                        const res = await this.$server.search('products', {
                            seller: seller._id || seller,
                            'details.warehouse': this.idWharhouse._id,
                            limit: 4000,
                        });
                        if (res.content.results) {
                            this.products = res.content.results;
                        } else this.products = [];
                    }
                }

                if (action && action == 'product') {
                    this.timeserchproduct = seller;
                    await this.getTotalOrdersPaid({
                        Response: 'Orders',
                        DateType: this.timeserchorders,
                        country: await this.warhouseSelected,
                        Seller: this.timeserchseller ? this.timeserchseller._id || this.timeserchseller : null,
                        product: this.timeserchproduct ? this.timeserchproduct._id || this.timeserchproduct : null
                    });
                }
            } else {
                if (action && action == 'Seller') {
                    this.timeserchseller = null;
                    this.timeserchproduct = null;
                    await this.getTotalOrdersPaid({
                        Response: 'Orders',
                        DateType: this.timeserchorders,
                        country: await this.warhouseSelected,
                        Seller: this.timeserchseller ? this.timeserchseller._id || this.timeserchseller : null,
                    });
                    this.products = [];
                    const res = await this.$server.search('products', {
                        'details.warehouse': this.idWharhouse._id,
                        limit: 4000,
                    });
                    if (res.content.results) {
                        this.products = res.content.results;
                    } else this.products = [];
                }
                
                if (action && action == 'product') {
                    this.timeserchproduct = null;
                    await this.getTotalOrdersPaid({
                        Response: 'Orders',
                        DateType: this.timeserchorders,
                        country: await this.warhouseSelected,
                        Seller: this.timeserchseller ? this.timeserchseller._id || this.timeserchseller : null,
                        product: this.timeserchproduct ? this.timeserchproduct._id || this.timeserchproduct : null
                    });
                }
            }
        },
        async ChangeSellerConfirmation(seller, action) {
            if (seller) {
                if (action && action == 'Seller') {
                    this.timeserchseller = seller;
                    this.timeserchproduct = null;
                    await this.getTotalOrdersPaid({
                        Response: 'Confirmation',
                        DateType: this.timeserchconfirm,
                        country: await this.warhouseSelected,
                        Seller: this.timeserchseller 
                    });

                    if(this.timeserchseller != 'All') {
                        this.products = [];
                        const res = await this.$server.search('products', {
                            seller: seller._id || seller,
                            'details.warehouse': this.idWharhouse._id,
                            limit: 4000,
                        });
                        if (res.content.results) {
                            this.products = res.content.results;
                        } else this.products = [];
                    }
                }

                if (action && action == 'product') {
                    this.timeserchproduct = seller;
                    await this.getTotalOrdersPaid({
                        Response: 'Confirmation',
                        DateType: this.timeserchconfirm,
                        country: await this.warhouseSelected,
                        Seller: this.timeserchseller,
                        product: this.timeserchproduct ? this.timeserchproduct._id || this.timeserchproduct : null
                    });
                }
            } else {
                if (action && action == 'Seller') {
                    this.timeserchseller = null;
                    this.timeserchproduct = null;
                    await this.getTotalOrdersPaid({
                        Response: 'Confirmation',
                        DateType: this.timeserchconfirm,
                        country: await this.warhouseSelected,
                        Seller: this.timeserchseller
                    });
                    this.products = [];
                    const res = await this.$server.search('products', {
                        'details.warehouse': this.idWharhouse._id,
                        limit: 4000,
                    });
                    if (res.content.results) {
                        this.products = res.content.results;
                    } else this.products = [];
                }
                
                if (action && action == 'product') {
                    this.timeserchproduct = null;
                    await this.getTotalOrdersPaid({
                        Response: 'Confirmation',
                        DateType: this.timeserchconfirm,
                        country: await this.warhouseSelected,
                        Seller: this.timeserchseller,
                        product: this.timeserchproduct ? this.timeserchproduct._id || this.timeserchproduct : null
                    });
                }
            }
        },
        async ChangeSellerFees(seller) {
            this.timeserchsellerFees = seller._id;
            this.timeserchfees = 'all';
            await this.getTotalOrdersPaid({
                Response: 'Revenue',
                Seller: this.timeserchsellerFees,
                DateType: this.timeserchfees,
                country: await this.warhouseSelected,
            });
        },
        async ChangeSellerDelivery(seller) {
            this.timeserchsellerDelivery = seller;
            await this.getTotalOrdersPaid({
                Response: 'Shippings',
                Seller: this.timeserchsellerDelivery,
                DateType: this.timeserchdelivery,
                country: await this.warhouseSelected,
            });
        },
        async getUser() {
            const res = await this.$server.me('users');
            if (res.content) this.currentUser = res.content;
            else this.currentUser = {};
        },
        async ChangeTypeDateRevenu(event) {
            if (event.target.name == 'Paid') {
                this.timeserchsales = event.target.value;
            }
            if (event.target.name == 'Orders') {
                this.timeserchorders = event.target.value;
            }
            if (event.target.name == 'Processed') {
                this.timeserchrevenues = event.target.value;
            }
            if (event.target.name == 'Confirmation') {
                this.timeserchconfirm = event.target.value;
                this.timeserchseller = '';
                this.timeserchproduct = null;
            }
            if (event.target.name == 'Delivery') {
                this.timeserchdelivry = event.target.value;
            }
            if (event.target.name == 'Accounting') {
                this.timeserchaccounting = event.target.value;
            }
            if (event.target.name == 'Revenue') {
                this.timeserchfees = event.target.value;
            }
            if (event.target.value == 'all') {
                await this.getTotalOrdersPaid({
                    DateType: event.target.value,
                    Response: event.target.name,
                    country: await this.warhouseSelected,
                });
            }
        },
        async FindRecords(action, from, to) {
            let filters = {
                DateType: 'betweendate',
                dates: { from: from, to: to },
                Response: action,
                country: await this.warhouseSelected,
            };
            if (action == 'Paid') {
                this.from_paid = from;
                this.to_paid = to;
            }
            if (action == 'Orders') {
                this.from_orders = from;
                this.to_orders = to;
            }
            if (action == 'Processed') {
                this.from_revenues = from;
                this.to_confirm = to;
            }
            if (action == 'Confirmation') {
                this.from_confirm = from;
                this.to_revenues = to;
            }
            if (action == 'Delivery') {
                this.from_delivery = from;
                this.to_delivery = to;
            }
            if (action == 'Accounting') {
                this.from_accounting = from;
                this.to_accounting = to;
            }
            if (action == 'Revenue') {
                this.from_fees = from;
                this.to_fees = to;
                filters.Seller = this.timeserchsellerFees;
            }
            await this.getTotalOrdersPaid(filters);
        },
        async getTotalOrders() {
            const res = await this.$server.getTotalOrders('analytics');
            this.TotalOrder = res.content;
        },
        async getTotalFeesExpeditions() {
            const res = await this.$server.getTotalFeesExpeditions('analytics', {
                country: await this.warhouseSelected,
            });
            this.FeesExpeditions = res.content.sum;
            this.countExpeditions = res.content.count;
        },
        async getTotalSeller() {
            const res = await this.$server.getTotalSeller('analytics', {
                country: await this.warhouseSelected,
            });
            this.TotalSeller = res.content;
        },
        async getTotalProduct() {
            const res = await this.$server.getTotalProduct('analytics', {
                warehouse: await this.idWharhouse._id,
            });
            this.TotalProduct = res.content;
        },
        async getTotalOrdersPaid(filters) {
            let res;
            switch (filters.Response) {
                case 'Paid':
                    this.loadingsales = true;
                    res = await this.$server.getTotalOrdersPaid('analytics', filters);
                    this.loadingsales = false;
                    this.TotalOrdersPaid = res.content.sum;
                    this.countOrdersPaid = res.content.count;
                    break;
                case 'PendingPaid':
                    res = await this.$server.getTotalOrdersPaid('analytics', filters);
                    this.TotalOrdersPendingPaid = res.content.sum;
                    this.countOrdersPendingPaid = res.content.count;
                    break;
                case 'Processed':
                    this.loadingrevenu = true;
                    res = await this.$server.getTotalOrdersPaid('analytics', filters);
                    this.TotalOrdersNotProcessed = res.content.sum;
                    this.countOrdersProcessed = res.content.count;
                    this.loadingrevenu = false;
                    break;
                case 'PendingProcessed':
                    res = await this.$server.getTotalOrdersPaid('analytics', filters);
                    this.TotalOrdersPendingProcessed = res.content.sum;
                    this.countOrdersPendingProcessed = res.content.count;
                    break;
                case 'Revenue':
                    this.loadingfees = true;
                    res = await this.$server.getTotalOrdersPaid('analytics', filters);
                    this.Revenue = res.content.sum;
                    this.loadingfees = false;
                    break;
                case 'Orders':
                    this.loadingorders = true;
                    res = await this.$server.getTotalOrdersPaid('analytics', filters);
                    this.TotalOrder = res.content.count;
                    this.loadingorders = false;
                    break;
                case 'Confirmation':
                    this.loadingconfirm = true;
                    res = await this.$server.getTotalOrdersPaid('analytics', filters);
                    this.Confirmation = res.content.datas;
                    this.ConfirmationRate = res.content.rate;
                    this.loadingconfirm = false;
                    break;
                case 'Delivery':
                    this.loadingdelivery = true;
                    res = await this.$server.getTotalOrdersPaid('analytics', filters);
                    this.Delivery = res.content.datas;
                    this.DeliveryRate = res.content.rate;
                    this.loadingdelivery = false;
                    break;
                case 'Shippings':
                    if (filters.Seller != 'All') filters.Seller = filters.Seller._id;
                    res = await this.$server.getTotalOrdersPaid('analytics', filters);
                    this.dataDelivery = res.content.datas;
                    this.countshipp = res.content.datas[0];
                    this.countdeliv = res.content.datas[1];
                    this.countcancell = res.content.datas[2];
                    break;
                case 'Accounting':
                    this.loadingaccounting = true;
                    filters.user = this.currentUser.type;
                    filters.warhouse = this.idWharhouse._id;
                    filters.warhouseCountry = await this.warhouseSelected;
                    res = await this.$server.getTotalOrdersPaid('analytics', filters);
                    this.Accounting = res.content.datas;
                    this.loadingaccounting = false;
                    break;
                default:
            }
        },
    },
}
</script>

<style>
.date-container {
    width: max-content;
    top: 47px;
}
</style>
